import { ANWSER_GET_SUCCESS } from '../actions/answer';

export const initialState = {};

export default function answerReducer(state = initialState, action) {
  switch (action.type) {
    case ANWSER_GET_SUCCESS:
      if (!action.payload) {
        return state;
      }
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
